import DEFAULT_APP_SETTINGS from '../../public/config/app.settings.json';
import DEFAULT_AUTH_SETTINGS from '../../public/config/auth.settings.json';
export function getSettings() {
    const injectedAppSettings = window.getAppSettings;
    const injectedAuthSettings = window.getAuthSettings;
    if (process.env.NODE_ENV === 'production') {
        if (!injectedAppSettings || !injectedAuthSettings)
            throw new Error('Failed to inject production settings');
        return { app: injectedAppSettings(), auth: injectedAuthSettings() };
    }
    return {
        app: DEFAULT_APP_SETTINGS,
        auth: DEFAULT_AUTH_SETTINGS,
    };
}
